import { createTheme } from '@mui/material/styles';

const useTheme = () => {
  return createTheme({
    palette: {
      primary: {
        main: '#ff9100',
      },
    },

    components: {
      MuiTextField: {
        defaultProps: {
          variant: 'filled',
          fullWidth: true,
          autoComplete: 'off',
          spellCheck: false,
        },
      },
    },
  });
};

export default useTheme;
